__turbopack_context__.v({
  "buttonSuccess": "product-card-module__StYrXG__buttonSuccess",
  "description": "product-card-module__StYrXG__description",
  "doneIcon": "product-card-module__StYrXG__doneIcon",
  "footer": "product-card-module__StYrXG__footer",
  "image": "product-card-module__StYrXG__image",
  "imageWrapper": "product-card-module__StYrXG__imageWrapper",
  "isMobile": "product-card-module__StYrXG__isMobile",
  "main": "product-card-module__StYrXG__main",
  "modal": "product-card-module__StYrXG__modal",
  "name": "product-card-module__StYrXG__name",
  "overlay": "product-card-module__StYrXG__overlay",
  "overlayText": "product-card-module__StYrXG__overlayText",
  "price": "product-card-module__StYrXG__price",
  "productCard": "product-card-module__StYrXG__productCard",
  "weight": "product-card-module__StYrXG__weight",
});
